import { FaqItemContainer } from 'shared/containers/FaqItemContainer';
import { Faq } from '../Faq';
import { Banner } from '../Banner';
import { LinkButton, Responsive } from '@cian/ui-kit';
import * as style from './Contents.css';

interface IContentProps {
  welcome: JSX.Element;
  guide: JSX.Element;
}

export const Content: React.FC<IContentProps> = ({ welcome, guide }) => {
  return (
    <div>
      {welcome}
      <Responsive phone>
        <div className={style['btn-container']}>
          <LinkButton href="https://www.cian.ru/razmestit-obyavlenie/?channel=sob_guide" target="_blank">
            Разместить объявление за 0 ₽
          </LinkButton>
        </div>
      </Responsive>
      {guide}
      <Faq Item={FaqItemContainer} />
      <Banner />
    </div>
  );
};
